import { FC, Fragment } from 'react';
import { PageItem } from '../types';

interface ContentCmsProps {
  contents: PageItem[];
}

const ContentCms: FC<ContentCmsProps> = ({ contents }) => {
  return (
    <Fragment>
      {contents.map((content, index) => (
        <div
          style={{ order: content.orderDisplay }}
          key={index}
          className="main-page-section text-lh"
        >
          {!!content.pageContent?.desc && (
            <div className="title text-center mb-0 text-lg">{content.pageContent?.desc}</div>
          )}

          {!!content.pageContent?.sub && (
            <div className="text-md text-center">{content.pageContent?.sub}</div>
          )}
          <div dangerouslySetInnerHTML={{ __html: content.pageContent?.body }}></div>
        </div>
      ))}
    </Fragment>
  );
};

export default ContentCms;
